import { render, staticRenderFns } from "./BulkTagAssignModal.vue?vue&type=template&id=b1f9d76e&"
import script from "./BulkTagAssignModal.vue?vue&type=script&lang=js&"
export * from "./BulkTagAssignModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports